// extracted by mini-css-extract-plugin
module.exports = {"partner":"PartnerInformation_partner__n1i_p"};